import React from "react";

const HeroPlatform = () => {
  return (
    <div className="platform-section bg-white flex flex-col items-center justify-center px-6 py-10">
      <h1>
        The <span className="highlight">all-in-one</span> finance platform for startups
      </h1>

      <div className="platform-image-container">
        <img 
          src="/images/platform-diagram.png" 
          alt="rKube Services Platform Diagram" 
          className="platform-image"
        />
      </div>
    </div>
  );
};

export default HeroPlatform; 